// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"tower-3"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M15 22.0001H9L10.4889 9.59229C11.4122 10.1316 12.5878 10.1316 13.5111 9.59229L15 22.0001Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15 7C15 8.65685 13.6569 10 12 10C10.3431 10 9 8.65685 9 7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 4C10.3431 4 9 5.34315 9 7C9 8.65685 10.3431 10 12 10C13.6569 10 15 8.65685 15 7C15 5.34315 13.6569 4 12 4ZM12 4V2M13.572 10.1L15 22H9L10.428 10.1","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Tower3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tower-3',
    ref,
    icon: element,
  },
));

Tower3Icon.displayName = 'Tower3Icon';

export default Tower3Icon;
